module.exports = "/_next/static/images/sizeidBusinessApi-a1390dc3b96acf1a1c455fa166839a62.png";